
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import UserSettingsDropdown from './UserSettingsDropdown';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'UserSettingsButton',
  components: { UserSettingsDropdown },
})
export default class UserSettingsButton extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
}
